import { inject } from "@angular/core";
import { Router, type CanActivateFn } from "@angular/router";
import {
  ProgressStep,
  progressStepRoutingPathMap,
} from "../../components/process/ui/progress-bar/progress-bar-stepes.enum";
import { RoutingPaths } from "../enums/routing-paths.enum";
import { PolicyStore } from "../store/policy.store";
import { ProcessStore } from "../store/process.store";

export const procesStepValidityGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const processStore = inject(ProcessStore);
  const policyStore = inject(PolicyStore);

  const currentStep = progressStepRoutingPathMap.getKey(
    state.url.split("/").pop() as RoutingPaths,
  ) as ProgressStep;
  const currentStepIndex = processStore.processSteps.find(
    (step) => step.value === currentStep,
  )?.index;

  if (!currentStepIndex || currentStepIndex === 0) {
    return true;
  }

  const previousStep = processStore.processSteps.find(
    (step) => step.index === currentStepIndex! - 1,
  )!.value;

  const isPreviousStepValid = processStore.stepValidity()[previousStep].valid;

  if (!isPreviousStepValid) {
    return router.createUrlTree([
      RoutingPaths.scb,
      policyStore.extractPolicyType(state.url)?.toLocaleLowerCase(),
      progressStepRoutingPathMap.get(previousStep),
    ]);
  }

  return true;
};
